import script from "./dependants-incorporations-table.vue?vue&type=script&setup=true&lang=js"
export * from "./dependants-incorporations-table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__